module.exports = {
  filterAjaxList: [
    {
      url: '/api/label/brand/label',
      method: 'post',
      param: {},
      flagKey: 'brand',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/platform/label',
      method: 'post',
      param: {},
      flagKey: 'platform',
      id: 'name',
      name: 'name'
    }
  ],
  detailInfos: [
    {
      title: '指数信息',
      id: 'contentInfo',
      updateType: 1, // 更新类型后端保存接口需要用到
      initWidth: '55',
      isSaveLoading: false,
      infosList: [
        {
          key: 'platform',
          label: '平台',
          isRequired: true,
          noInsert: true,
          type: 'select'
        }, {
          key: 'brand',
          label: '品牌',
          isRequired: true,
          noInsert: true,
          type: 'select'
        }, {
          key: 'date',
          label: '日期',
          type: 'date',
          isRequired: true,
          noInsert: true,
          dateType: 'date',
          valueFormat: 'yyyy-MM-dd'
        }, {
          key: 'searchIndex',
          label: '指数',
          isRequired: true
        }
      ]
    }
  ]
}
